<app-data-setup-common-content [isIos]="false" [isTmo]="false" [isGeneration]="true"></app-data-setup-common-content>
<div class="fourth-generation-container page-section">
    <div class="back-section">
        <a (click)="back()"><img src="assets/icon/primary-back-arrow.svg" width="20" height="20"
                alt="Back Arrow Icon">Back</a>
    </div>
    <h2 class="container-title">4G PHONE INSTRUCTIONS:</h2>
    <section class="instructions-section">
        <div class="flex-text">
            <div class="number-image">
                <img src="assets/icon/circle-one-icon.svg" width="20" height="20" alt="Circle Number Icon">
            </div>
            <p>Press <b>"Menu"</b> button on your device</p>
        </div>
        <div class="flex-text">
            <div class="number-image">
                <img src="assets/icon/circle-two-icon.svg" width="20" height="20" alt="Circle Number Icon">
            </div>
            <p>Tap <b>“Settings” > “Wireless Controls”</b> or <b>“Wireless and Network” > “Mobile Networks”</b></p>
        </div>
        <div class="info-banner warning-background">
            <div class="flex">
                <img src="assets/icon/banner-warning-icon.svg" width="32" height="32" alt="Warning Icon">
                <div class="banner-content">
                    <h5 class="title">Attention</h5>
                    <p class="smaller desc-a last">Make sure <b>“Data Roaming”</b> and <b>“Use Only 2G Networks”</b> are
                        both <b>UNCHECKED</b></p>
                </div>
            </div>
        </div>
        <div class="flex-text">
            <div class="number-image">
                <img src="assets/icon/circle-three-icon.svg" width="20" height="20" alt="Circle Number Icon">
            </div>
            <p>Tap <b>Access Point Names</b></p>
        </div>
        <div class="flex-text">
            <div class="number-image">
                <img src="assets/icon/circle-four-icon.svg" width="20" height="20" alt="Circle Number Icon">
            </div>
            <p>Press Menu button and select New <b>APN</b></p>
        </div>
        <div class="flex-text bottom">
            <div class="number-image">
                <img src="assets/icon/circle-five-icon.svg" width="20" height="20" alt="Circle Number Icon">
            </div>
            <p>Enter the following information:</p>
        </div>
        <div class="information-part">
            <div class="box desktop">
                <div class="key-value-flex" *ngFor="let info of instructionTable.slice(0, 8)">
                    <p class="smaller key"><b>{{info.key}}</b></p>
                    <p class="smaller value" *ngIf="!info.href">{{info.value}}</p>
                    <p class="smaller value" *ngIf="!!info.href"><a class="word-break"
                            href="http://wholesale.mmsmvno.com/mms/wapenc">{{info.value}}</a></p>
                </div>
            </div>
            <div class="box desktop">
                <div class="key-value-flex" *ngFor="let info of instructionTable.slice(8)">
                    <p class="smaller key"><b>{{info.key}}</b></p>
                    <p class="smaller value">{{info.value}}</p>
                </div>
            </div>
            <div class="box responsive">
                <div class="key-value-flex" *ngFor="let info of instructionTable">
                    <p class="smaller key"><b>{{info.key}}</b></p>
                    <p class="smaller value" *ngIf="!info.href">{{info.value}}</p>
                    <p class="smaller value" *ngIf="!!info.href"><a class="word-break"
                            href="http://wholesale.mmsmvno.com/mms/wapenc">{{info.value}}</a></p>
                </div>
            </div>
        </div>
        <div class="flex-text last">
            <div class="number-image">
                <img src="assets/icon/circle-six-icon.svg" width="20" height="20" alt="Circle Number Icon">
            </div>
            <p>Press the <b>“Menu”</b> button on your device and then <b>“Save”</b> on the screen.</p>
        </div>
    </section>
    <section class="last-section">
        <h5>To manage your account go to</h5>
        <div class="link-flex">
            <a [routerLink]="[ACCOUNT_ROUTE_URLS.BASE + '/' + ACCOUNT_ROUTE_URLS.SUMMARY]" routerLinkActive="active"
                [routerLinkActiveOptions]="{exact: true}">Account Summary<img src="assets/icon/circle-right-arrow.svg"
                    width="16" height="16" alt="Circle Right Arrow"></a>
        </div>
        <button class="button primary" (click)="back()">Got it</button>
    </section>
</div>